import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { history, latinAlphabet } from '../../utils/variables';
import { getDirection, pexios, toast } from '../../utils/functions';
import { setRouterData } from '../../redux/actions';
import Pricing from '../../components/expert/Pricing';
import Calculator from '../../components/expert/Calculator';
import Modal from "../../components/master/Modal";
import ShowPlate from './ShowPlate';
import { useTranslation } from 'react-i18next';

export default function FinalPricing() {

    const dispatch = useDispatch();
    const { id } = useSelector(store => store.routerData);
    const user = useSelector(store => store.user);
    const { t, i18n } = useTranslation();

    const [accident, setAccident] = useState({});
    const [items, setItems] = useState({
        accessories: [],
        wages: [],
        extras: [],
        deducts: [],
    });
    const [selectedItems, setSelectedItems] = useState({
        accessories: [],
        wages: [],
        extras: [],
        deducts: [],
    });
    const [loader, setLoader] = useState(false);///for submit
    const [description, setDescription] = useState('');
    const [lossesIndex, setLossesIndex] = useState(0);
    const [isModalOpened, setIsModalOpened] = useState(false);
    const [fixCar, setFixCar] = useState(false);
    const [loading, setLoading] = useState(true);///for items
    const [recomPrice,setRecomPrice] =useState({
        accessories: '',
        wages: '',
    });

    useEffect(() => {
        pexios('api/get_report_option')
            .then(async res => {
                setItems({
                    accessories: res.data.accessories,
                    wages: res.data.wages,
                    extras: res.data.extras,
                    deducts: res.data.deducts,
                })
            });
       id && pexios('/api/v2/get_accident','post',{accident_id: id , type : 'final_pricing'})
            .then( res => {
                const accident = res.data.data;
                setAccident(accident);

                let insurance_type = accident.insurance_type;
                if ((insurance_type === 'body' && accident.culprit.car && accident.culprit.car.car_type_id === 1) ||
                    (insurance_type === 'third' && accident.losses[lossesIndex].type==='car' && accident.losses[lossesIndex].car.car_type_id === 1))
                    setFixCar(true);
            });
    }, [id,lossesIndex]);
    useEffect(()=>{
        if(items.accessories.length){
            setLoading(false)
        }
    },[items])

    function submitValue(type, data) {
        setSelectedItems(prevState => ({
            ...prevState,
            [type]: data,
        }));
    }
    function submit(isFinished) {
        setLoader(true);
        pexios('api/add_report', 'post', {
            accident_id: id,
            losses_id: accident.losses.length ? accident.losses[lossesIndex].id : 0,
            accessory: JSON.stringify(selectedItems.accessories),
            wage: JSON.stringify(selectedItems.wages),
            extra: JSON.stringify(selectedItems.extras),
            deduct: JSON.stringify(selectedItems.deducts),
            description,
            isFinished,
        })
            .then(() => {
                setIsModalOpened(false)
                if (!accident.losses.length || accident.losses.length - 1 === lossesIndex) {
                    dispatch(setRouterData({}));
                    // toast(`همکار محترم، جناب ${user.fname} ${user.lname} از این که ما را در کارشناسی این خسارت یاری نمودید سپاسگزاریم.با آرزوی روزی پر انرژی برای شما.`, 'success');
                    toast(t('Greeting expert alert',{fullname :user.full_name}))
                    setTimeout(() => {
                        history.replace('/expert-waiting');
                    }, 5000);
                } else {
                    setLoader(false);
                    setSelectedItems({
                        accessories: [],
                        wages: [],
                        extras: [],
                        deducts: [],
                    });
                    //
                    setRecomPrice({
                        accessories: '',
                        wages:''
                    })
                    setDescription('');
                    setLossesIndex(prevState => prevState + 1);
                    const element = document.getElementById('final-pricing');
                    setTimeout(() => element.scrollIntoView());
                }
            });
    }

    //////
    function getPrice (id,type){
        if(accident &&['accessories','wages'].includes(type) && fixCar){
            let info ={
                carInfo:'',
                insuranceType: accident.insurance_type,
                title: type,
                id: id
            }
            let insurance_type = accident.insurance_type;
            if(insurance_type === 'body') info = {...info,carInfo:accident.culprit.car}
            else info ={...info,carInfo: accident.losses[lossesIndex].car};
            pexios('api/get_recommended_price','post', info)
                .then( res=>{
                    setRecomPrice(prevState => ({
                        ...prevState,
                        [type]: res.data
                    }));
                })
        }
    }

    return (
        <div className='content final-pricing'>
            <Modal visible={isModalOpened}>
                <div className='modal-content text-center p10'>
                    <p className='title'>
                        {t('Has your examine completed?')}
                    </p>
                    <button
                        className='btn btn-circle btn-green btn-block mt20'
                        disabled={loader && 'disabled'}
                        onClick={() => submit(true)}
                    >
                        {
                            loader ?
                                <i className='fas fa-spinner fa-spin' /> :
                                t('Yes,deliver')
                        }
                    </button>
                    <button
                        className='btn btn-circle btn-blue btn-block mt10'
                        disabled={loader && 'disabled'}
                        onClick={() => submit(false)}
                    >
                        {
                            loader ?
                                <i className='fas fa-spinner fa-spin' /> :
                                t('No, i need time')
                        }
                    </button>
                    <button
                        className='btn btn-circle btn-block close-btn'
                        onClick={() => setIsModalOpened(false)}
                    >
                        {t('Reject')}
                    </button>
                </div>
            </Modal>
            {loading ?
                <Modal visible={loading}>
                    <div className='loader-modal'>
                        <i className='fas fa-spinner fa-spin'/>
                    </div>
                </Modal>
                :<>
                    <h4 className='mt20 text-center' id='final-pricing'>
                        {
                            accident.insurance_type === 'body' ?
                                t('Damage assessment report sheet') :
                                `${t('Damage assessment report sheet')} ${t('Losses')} ${t(latinAlphabet[lossesIndex])}`
                        }
                    </h4>
                    {
                        //accident.insurance_type && 
                        <>
                        {accident.insurance_type === 'body' &&
                        <div className='plate-container'>
                            <ShowPlate plate={accident.culprit.car}/>
                        </div>
                        //:
                        }
                        {
                        accident.insurance_type === 'third' && accident.losses[lossesIndex].type !== 'object' && 
                        <div className='plate-container'>
                            <ShowPlate plate={accident.losses[lossesIndex].car}/>
                        </div>
                        }
                        </>
                    }
                    <Pricing
                        title={t('Accessories list')}
                        placeholder={t('Accessory title')}
                        pickerData={items.accessories}
                        submit={(value) => submitValue('accessories', value)}
                        value={selectedItems.accessories}
                        fixItem={fixCar}
                        getPrice={(id)=>getPrice(id,'accessories')}
                        recomPrice={recomPrice.accessories}
                    />
                    <Pricing
                        title={t('Wage list')}
                        placeholder={t('Wage title')}
                        pickerData={items.wages}
                        submit={(value) => submitValue('wages', value)}
                        value={selectedItems.wages}
                        fixItem={fixCar}
                        getPrice={(id)=>getPrice(id,'wages')}
                        recomPrice={recomPrice.wages}
                    />
                    <Pricing
                        title={t('Extra list')}
                        placeholder={t('Extra title')}
                        pickerData={items.extras}
                        submit={(value) => submitValue('extras', value)}
                        value={selectedItems.extras}
                        fixItem={false}
                    />
                    <Pricing
                        title={t('Deduct list')}
                        placeholder={t('Deduction title')}
                        pickerData={items.deducts}
                        submit={(value) => submitValue('deducts', value)}
                        value={selectedItems.deducts}
                        fixItem={false}
                    />
                    <Calculator
                        accessories={selectedItems.accessories}
                        wages={selectedItems.wages}
                        extras={selectedItems.extras}
                        deducts={selectedItems.deducts}
                    />
                    <div className={`input-parent ${getDirection(i18n.language) === 'rightToLeft'? 'rtl':'ltr'} mt20`}>
                        <textarea
                            rows='4'
                            placeholder={t('Description')}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                        />
                    </div>
                    <button
                        className='btn btn-block btn-green btn-circle mt20'
                        onClick={() => setIsModalOpened(true)}
                    >
                        {t('Final confirm')}
                    </button>
                </>}

        </div>
    );

}
